<template>
  <n-menu tabindex="0" ref="menu" @keydown="onKeyDown">
    <n-menu-group :subheader="$t('embedLinkMenu.displayAs')">
      <n-list-item
        v-for="(option, index) in items"
        :key="option.name"
        :leadingIcon="option.icon"
        :text="$t(`embedLinkMenu.${option.name}`)"
        :active="selected === index"
        @click="onSelect(option.name)"
        @mouseenter="selected = index"
      />
    </n-menu-group>
  </n-menu>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'

interface EmbedOptions {
  name: string
  icon: string
  rotate: string
}

const ALL_OPTIONS: EmbedOptions[] = [
  { name: 'bookmark', icon: 'bookmark', rotate: '0' },
  { name: 'link', icon: 'link', rotate: '0' },
  { name: 'embed', icon: 'selector', rotate: '1' }
]

@Component
export default class EmbedLinkMenu extends Vue {
  /** Which of bookmark / link / embed to list */
  @Prop({ default: () => ['bookmark', 'link', 'embed'] }) readonly options!: string[]

  onSelect!: Function
  selected = 0

  get items(): EmbedOptions[] {
    return ALL_OPTIONS.filter(option => this.options.includes(option.name))
  }

  mounted() {
    setTimeout(() => {
      const menu = this.$refs.menu as any
      menu.$el.focus()
    }, 10)
  }

  onKeyDown(event: KeyboardEvent) {
    event.preventDefault()
    event.stopPropagation()
    if (event.code === 'ArrowDown') {
      this.selected = this.selected + 1
      if (this.selected >= this.items.length) {
        this.selected = 0
      }
    } else if (event.code === 'ArrowUp') {
      this.selected = this.selected - 1
      if (this.selected < 0) {
        this.selected = this.items.length - 1
      }
    } else if (event.code === 'Enter') {
      const choice = this.items[this.selected]
      if (choice) this.onSelect(choice.name)
      return true
    } else if (event.key === 'Escape') {
      this.onSelect('link')
      return true
    }
  }
}
</script>

<style lang="scss" scoped>
@use '@/assets/styles' as *;

.overlay {
  @include notch-style-floating;
  width: 300px;
  background-color: $notch-color-neutral-grey-000;
  border-radius: $notch-radius-2x;

  padding: $notch-space-2_5x $notch-space-2x;

  outline: none;
}

.title {
  @include notch-text-overline-S;
  color: $notch-color-neutral-sand-600;
  padding-left: $notch-space-2x;
  padding-top: $notch-space-1x;
  padding-bottom: $notch-space-1x;
}

.entry {
  @include notch-text-label-light-S;
  height: $notch-space-10x;
  display: flex;
  align-items: center;
  padding-left: $notch-space-3x;
  cursor: pointer;
}

.selected {
  background-color: $notch-color-neutral-sand-100;
  border-radius: $notch-radius-full;
}
</style>
